import React from 'react'

import { Box, TextField, InputAdornment, Button } from '@material-ui/core'
import { Search, Clear as ClearIcon } from '@material-ui/icons'
import { makeStyles, Theme } from '@material-ui/core/styles'

import { LeadsFilters } from '../../../../hooks/Outreach/useLeads'

interface LeadsSearchAndFilterProps {
    filters: LeadsFilters
    onSearchChange: (value: string) => void
    onClearFilters: () => void
}

const useStyles = makeStyles((theme: Theme) => ({
    searchFilterContainer: {
        display: 'flex',
        gap: theme.spacing(2),
        padding: theme.spacing(2),
        alignItems: 'center',
        backgroundColor: '#f8fafc',
        borderBottom: '1px solid #e2e8f0',
    },
    searchField: {
        flex: 1,
        minWidth: '200px',
    },
}))

export const LeadsSearchAndFilter: React.FC<LeadsSearchAndFilterProps> = ({
    filters,
    onSearchChange,
    onClearFilters,
}) => {
    const classes = useStyles()

    const hasActiveFilters = !!filters.search

    return (
        <Box className={classes.searchFilterContainer}>
            <TextField
                placeholder="Search leads..."
                value={filters.search || ''}
                onChange={(e) => onSearchChange(e.target.value)}
                className={classes.searchField}
                variant="outlined"
                size="small"
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <Search />
                        </InputAdornment>
                    ),
                }}
            />
            {hasActiveFilters && (
                <Button
                    startIcon={<ClearIcon />}
                    onClick={onClearFilters}
                    size="small"
                >
                    Clear Filters
                </Button>
            )}
        </Box>
    )
}
